import { Text } from 'ui';

const backgroundImageSource = `/${String(import.meta.env.VITE_APP_CONFIG)}/landing.jpg`;

export const ContentLeft = () => (
  <>
    <img alt="" className="onboarding-layout-content__left__bg-image" src={backgroundImageSource} />
    <div className="onboarding-layout-content__left__text">
      <Text className="onboarding-layout-content__left__text-inner" weight="bold">
        {import.meta.env.VITE_APP_DESCRIPTION}
      </Text>
    </div>
  </>
);
